import { network } from './dealer/account/Network/reducer';
import { dealerLogin } from './dealer/login/reducer';

export const localStorageReducers = {
  network,
  dealerLogin,
};
